import { useState, useEffect } from "react";
import { AlertTriangle, Info, Wand2 } from "lucide-react";
import api from "@/lib/api";

// Auto-classify a reference image via backend vision. Falls back to "character".
export async function classifyRef(url) {
  try {
    const { data } = await api.post("/references/classify", { url });
    return { type: data.type || "character", label: data.label || "" };
  } catch {
    return { type: "character", label: "" };
  }
}

// Detect conflicting references (e.g. multiple characters) before generation.
export function useRefAnalysis(refs) {
  const [warnings, setWarnings] = useState([]);
  const key = JSON.stringify((refs || []).map((r) => r.type || "auto"));
  useEffect(() => {
    if (!refs || refs.length < 2) { setWarnings([]); return; }
    let active = true;
    api.post("/references/analyze", { references: refs })
      .then(({ data }) => active && setWarnings(data.warnings || []))
      .catch(() => {});
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return warnings;
}

export function RefWarnings({ warnings }) {
  if (!warnings?.length) return null;
  return (
    <div className="space-y-1.5" data-testid="ref-warnings">
      {warnings.map((w, i) => (
        <div key={i} className={`flex items-start gap-2 text-[11px] leading-snug rounded-md px-2.5 py-1.5 border ${
          w.level === "warning" ? "border-amber-500/40 bg-amber-500/10 text-amber-300" : "border-zinc-700 bg-zinc-800/40 text-zinc-400"}`}>
          {w.level === "warning" ? <AlertTriangle size={13} className="mt-0.5 shrink-0" /> : <Info size={13} className="mt-0.5 shrink-0" />}
          <span>{w.message}</span>
        </div>
      ))}
    </div>
  );
}

export const AutoTag = () => (
  <span className="inline-flex items-center gap-1 text-[9px] text-gold/80"><Wand2 size={10} /> auto</span>
);
